import { DestroyRef } from "@angular/core";
import { FormArray } from "@angular/forms";
import { RefuelBeforeFirstFlight } from "../../../models/refuel-before-first-flight.model";
import { FuelGroup, MaxTank, REFUEL_FIELDS, buildFuelGroup } from "../fuel-row/fuel-row";

function refuelRow(refuel: RefuelBeforeFirstFlight | null, units: string[], maxTank: MaxTank, destroyRef: DestroyRef): FuelGroup {
    return buildFuelGroup(
        {
            id: refuel?.id ?? null,
            name: refuel?.fuelName ?? null,
            arrival: refuel?.remainingFuel ?? null,
            planned: refuel?.fuelPlanned ?? null,
            refuel: refuel?.refuel ?? null,
            total: refuel?.totalFuel ?? null,
            location: refuel?.refuelLocation ?? null,
        },
        { fields: REFUEL_FIELDS, units: units, maxTank: maxTank, withId: true },
        destroyRef,
    );
}

/** A flight without a refuel still offers one, empty, to log it. */
export function buildRefuelArray(refuels: RefuelBeforeFirstFlight[], units: string[], maxTank: MaxTank, destroyRef: DestroyRef) {
    return new FormArray((refuels.length ? refuels : [null]).map((refuel) => refuelRow(refuel, units, maxTank, destroyRef)));
}

export type RefuelArray = ReturnType<typeof buildRefuelArray>;
